<template>
    <div class="info">
        <div class="title">
            <h1>{{ level }}考试报名表<span> / Registration Form for {{ level }} Examination </span></h1>
        </div>
        <el-form :model="enrollInfo" :rules="enrollRules" ref="enrollInfo" label-width="130px" label-position="left" @submit.native.prevent>
            <h2>工作履历<span @click="addWork">添加</span></h2>
            <div class="workList" :class="{'last':index}" v-for="(item,index) in enrollInfo.llll" :key="item.id">
				<h2>{{item.status==0?"现工作单位":"前工作单位"}}</h2>
                <el-form-item label="时间阶段" :prop="'llll.' + index + '.endDate'" :rules="{
                    required: llllll, message: '请选择时间阶段', trigger: 'change'
                }">
                    <timePiker :startDate.sync="item.startDate" :endDate.sync="item.endDate" :unlink-panels="true"></timePiker>
                </el-form-item>
                <el-form-item label="工作单位名称" :prop="'llll.' + index + '.companyName'" :rules="{
                    required: llllll, message: '请输入工作单位', trigger: 'blur'
                }">
                    <el-input v-model="item.companyName" placeholder="请输入前工作单位名称"></el-input>
                </el-form-item>
				<el-form-item label="单位所在行业" :prop="'llll.' + index + '.companyIndustry'" :rules="{
				    required: llllll, message: '请选择单位所在行业', trigger: 'blur'
				}">
					<el-select clearable v-model="item.companyIndustry" placeholder="请选择工作单位所在行业">
						<el-option
							v-for="itemm in companyIndustryList"
							:key="itemm.value"
							:label="itemm.label"
							:value="itemm.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="工作单位规模" :prop="'llll.' + index + '.companyScale'" :rules="{
				    required: llllll, message: '请输入工作单位', trigger: 'blur'
				}">
					<el-select clearable v-model="item.companyScale" placeholder="请选择工作单位规模">
					    <el-option
					        v-for="item in companyScaleList"
					        :key="item.value"
					        :label="item.label"
					        :value="item.value">
					    </el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="工作单位类型" :prop="'llll.' + index + '.companyScale'" :rules="{
				    required: llllll, message: '请选择工作单位类型', trigger: 'blur'
				}">
					<el-select clearable v-model="item.companyType" placeholder="请选择工作单位类型">
					    <el-option
					        v-for="item in companyTypeList"
					        :key="item.value"
					        :label="item.name"
					        :value="item.value">
					    </el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="任职部门" :prop="'llll.' + index + '.department'" :rules="{
				    required: llllll, message: '请输入任职部门', trigger: 'blur'
				}">
					<el-input v-model="item.department" placeholder="请输入任职部门"></el-input>
				</el-form-item>
				<el-form-item label="职位" :prop="'llll.' + index + '.position'" :rules="{
				    required: llllll, message: '请选择职位', trigger: 'blur'
				}">
					<el-select clearable v-model="item.position" placeholder="请选择职位">
					    <el-option
					        v-for="item in positionList"
					        :key="item.value"
					        :label="item.name"
					        :value="item.value">
					    </el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="主要职责" :prop="'llll.' + index + '.duty'" :rules="{
				    required: llllll, message: '请输入相关内容', trigger: 'blur'
				}">
				    <el-input type="textarea" autosize v-model="item.duty" placeholder="请输入相关内容"></el-input>
				</el-form-item>
                <el-form-item label="证明人" :prop="'llll.' + index + '.firstReterence'" class="multiple" :rules="{
                    required: llllll, validator: ooooRules, trigger: 'blur', index: index
                }">
                    <el-input v-model="item.firstReterence" placeholder="请输入证明人姓名"></el-input>
                    <el-input v-model="item.firstPosition" placeholder="请输入证明人职位"></el-input>
                    <el-input v-model="item.firstPhone" placeholder="请输入证明人电话"></el-input>
                </el-form-item>
                <el-button class="remove" v-if="index" @click="removeWork(index)">删除</el-button>
            </div>
        </el-form>
        <div class="buttons">
            <el-button @click="prev">返回上一步修改</el-button>
            <el-button :loading="submitLoading" @click="next(true)">保存进行下一步</el-button>
            <el-button :loading="saveLoading" @click="next(false)">暂存</el-button>
        </div>
    </div>
</template>

<script>
import uploadImages from '@/components/imageUpLoad'
import { listByType } from '@/api/cms'
import { enrollCompanyAdd,lastEnrollComdetail,enrollCompanyUpdate,EnrollCertAdd,EnrollCertList,EnrollCertUpdate } from '@/api/enroll'
import { scrollTo } from '@/utils/scrollTo'
export default {
    name: 'info',
    components: {
        uploadImages
    },
    data(){
        let firstReterenceRules = (rule, value, callback) => {
            if(this.enrollInfo.firstReterence && this.enrollInfo.firstPosition && this.enrollInfo.firstPhone){
                return callback()
            }else{
                return callback(new Error('请输入证明人信息'))
            }
        }

        let ooooRules = (rule, value, callback) => {
            let index = rule.index
            if(this.enrollInfo.llll[index].firstReterence && this.enrollInfo.llll[index].firstPosition && this.enrollInfo.llll[index].firstPhone){
                return callback()
            }else{
				return callback()
                // return callback(new Error('请输入证明人信息'))
            }
        }
        return {
            ooooRules,
			llllll:false,
            level: '',
            submitLoading: false,
            saveLoading: false,
			testurlid:'',
            companyIndustryList: [
                { label: '银行', value: '1' },
                { label: '证券', value: '2' },
                { label: '保险', value: '3' },
                { label: '多元/互联网金融', value: '4' },
                { label: '商贸', value: '5' },
                { label: '会计审计', value: '6' },
                { label: '核工业', value: '7' },
                { label: '兵器兵装', value: '8' },
                { label: '航天', value: '9' },
                { label: '航空工业', value: '10' },
                { label: '律师/法律', value: '11' },
                { label: '机械制造', value: '12' },
                { label: '建筑/建材', value: '13' },
                { label: '房地产', value: '14' },
                { label: '有色冶金', value: '15' },
                { label: '纺织工业', value: '16' },
                { label: '电子工业', value: '17' },
                { label: '信息/通信', value: '18' },
                { label: '批发/零食/租赁', value: '19' },
                { label: '农/林/牧/渔,', value: '20' },
                { label: '水利/电力', value: '21' },
                { label: '交通/物流/仓储', value: '22' },
                { label: '文化传媒', value: '23' },
                { label: '教育科研', value: '24' },
                { label: '咨询顾问', value: '25' },
                { label: '食品', value: '26' },
                { label: '旅游/餐饮/服务业', value: '27' },
                { label: '医疗医药', value: '28' },
                { label: '公共组织', value: '29' },
                { label: '能源/石化/矿产', value: '30' },
                { label: '其他', value: '-1' }
            ],
            companyScaleList: [
                { label: '100人以下', value: '1' },
                { label: '100-999人', value: '2' },
                { label: '1000-9999人', value: '3' },
                { label: '10000人以上', value: '4' },
            ],
            companyTypeList: [],
            positionList: [],
            typeList: [
                { label: '风控类', value: 1 },
                { label: '经济类', value: 2 },
                { label: '金融从业类', value: 3 },
				{ label: '财税/资产评估类', value: 4 },
				{ label: '审计类', value: 5 },
				{ label: '合规/法务类', value: 6 },
				{ label: '人力资源类', value: 7 },
				{ label: '信息技术类', value:8 },
				{ label: '质量/安全/环境类', value: 9 },
				{ label: '工程类', value: 10 },
				{ label: '项目/产品管理类', value: 11 },
				{ label: '医药类', value: 12 },
				{ label: '教师类', value: 13 },
				{ label: '其他', value: 14 },
            ],
            region: [],
            enrollInfo: {
				status:0,
				tbInfoUserId:this.$route.params.id,
				startDate:'',
				endDate:'',
                companyName: '',
                companyIndustry: '',
                companyScale: '',
                companyType: '',
                department: '',
                position: '',
                duty: '',
                firstReterence: '',
                firstPosition: '',
                firstPhone: '',
                llll: [
                    {
						status:0,
						tbInfoUserId:this.$route.params.id,
						startDate:'',
                        endDate: '',
                        companyName: '',
                        firstPhone: '',
                        firstPosition: '',
                        firstReterence: '',
                        duty: '',
						companyIndustry:'',
						companyScale: '',
						department:'',
                    }
                ],
                ssss: [
                    {
						tbInfoUserId:this.$route.params.id,
						type:1,
                        certName: '',
                        certUrl: '',
                        certType: ''
                    }
                ],
            },
            enrollRules: {},
        }
    },
	computed:{
	    timing:{
	        get(){
	            return [this.enrollInfo.startDate, this.enrollInfo.endDate]
	        },
	        set(val){
	            this.enrollInfo.startDate = val[0]
	            this.enrollInfo.endDate = val[1]
	        },
	    },
		timinggggg:{
		    get(){
		        return [this.enrollInfo.startDate, this.enrollInfo.endDate]
		    },
		    set(val){
		        this.enrollInfo.startDate = val[0]
		        this.enrollInfo.endDate = val[1]
		    },
		},
	},
    mounted(){
		listByType("work_title").then(res => {
			this.positionList = res
		})
		listByType("enterprise_type").then(res => {
			this.companyTypeList = res
		})
        this.$emit('changeIndex',3)
        this.level = this.$route.params.level
        scrollTo(0,50)
		this.testurlid=this.$route.params.id
		if(this.testurlid){
			lastEnrollComdetail({tbInfoUserId:this.testurlid}).then(res=>{
				console.log(res)
				if(res==null){
					this.fristrequest=true
				}else{
					let x
					res.forEach((item,index)=>{
						if(item.status==0){
							x=index
						}
					})
					this.fristrequest=false
					let needdata=res[x]
					let enrodata = [...res]
					enrodata.splice(x,1)
					
					let enrollInfo = {...enrollInfo}
					enrollInfo.llll=[needdata].concat(enrodata)
					
					setTimeout(() => {
						this.enrollInfo = enrollInfo
					}, 100)
					
					
					
					
				}
			})
			
		}
        // setTimeout(() => {
        //     this.enrollInfo.idImage = 'http://nuxt.ml:3000/uploads/1555381523321.jpg'
        // })
    },
    methods:{
        addWork(){
            this.enrollInfo.llll.push({
                status:1,
                tbInfoUserId:this.$route.params.id,
                startDate:'',
                endDate: '',
                companyName: '',
                firstPhone: '',
                firstPosition: '',
                firstReterence: '',
                remark: '',
            })
        },
        removeWork(index){
            this.enrollInfo.llll.splice(index,1)
        },
        addTitle(){
            this.enrollInfo.ssss.push({
                certName: '',
                certUrl: '',
                certType: '',
				tbInfoUserId:this.$route.params.id,
				type:1
            })
        },
        removeTitle(index){
            this.enrollInfo.ssss.splice(index,1)
        },
        prev(){
			this.$router.go(-1)
            // this.$router.push(`/enroll/education/${this.level}/${this.testurlid}`)
        },
        next(type){
			let postdata = {...this.enrollInfo}
			delete(postdata["llll"]);
			delete(postdata["ssss"]);
			let postdata1=this.enrollInfo.llll
			let postdata2=this.enrollInfo.ssss
			if(type){
			    this.$refs['enrollInfo'].validate((valid) => {
			        if (valid){
						this.submitLoading = true
						if(this.fristrequest){
							enrollCompanyAdd(postdata1).then(res=>{
								this.submitLoading = false
								this.$router.push(`/enroll/preview/${this.level}/${this.testurlid}`)
							}).catch(res=>{
								this.submitLoading = false
							})
							
						}else{
							enrollCompanyUpdate(postdata1).then(res=>{
								this.submitLoading = false
								this.$router.push(`/enroll/preview/${this.level}/${this.testurlid}`)
							}).catch(res=>{
								this.submitLoading = false
							})
						}
			        }
			    }) 
			}else{
			    this.saveLoading = true
			    if(this.fristrequest){
			    	enrollCompanyAdd(postdata1).then(res=>{
			    		this.saveLoading = false
			    	}).catch(res=>{
			    		this.saveLoading = false
			    	})
			    }else{
			    	enrollCompanyUpdate(postdata1).then(res=>{
			    		this.saveLoading = false
			    	}).catch(res=>{
			    		this.saveLoading = false
			    	})
			    }
			}
        }
    }
}
</script>

<style scoped>
    @import './info.css';
    h2 span{font-size: 14px;color: #598fe6;text-decoration: underline;cursor: pointer;margin-left: 20px;font-weight: 500;position: relative;top: -1px;}
    .info >>> .multiple .el-input{display: block;margin-top: 10px;}
    .info >>> .multiple .el-input:first-child{margin-top: 0;}
    .workList.last{border-top: 1px solid #e6e6e6;padding-top: 20px;position: relative;}
    .remove{position: absolute;bottom: 0;right: 0;}
	.red{color: red;}
    .info >>> .el-button.el-button.remove{width: 100px;line-height: 30px;height: 30px;}
</style>
